import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.313 6.25A3.445 3.445 0 0 1 8.75 2.813h9c.881 0 1.743.354 2.413 1.024l3.5 3.5c.67.67 1.024 1.532 1.024 2.413v2.75a.937.937 0 1 1-1.875 0V9.75c0-.369-.145-.757-.475-1.087l-3.5-3.5c-.33-.33-.718-.476-1.087-.476h-9A1.57 1.57 0 0 0 7.188 6.25v17.5a1.57 1.57 0 0 0 1.562 1.563h7.5a.937.937 0 1 1 0 1.875h-7.5a3.445 3.445 0 0 1-3.437-3.438z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.5 3.125c.345 0 .625.28.625.625v5c0 .233.075.379.16.464.087.086.232.161.465.161h5a.625.625 0 1 1 0 1.25h-5c-.517 0-.997-.175-1.348-.527s-.527-.831-.527-1.348v-5c0-.345.28-.625.625-.625M22.5 16.875a3.125 3.125 0 1 0 0 6.25 3.125 3.125 0 0 0 0-6.25M18.125 20a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M24.625 22.5c.345 0 .625.28.625.625V27.5a.625.625 0 1 1-1.25 0v-4.375c0-.345.28-.625.625-.625M20.375 22.5c.345 0 .625.28.625.625V27.5a.625.625 0 1 1-1.25 0v-4.375c0-.345.28-.625.625-.625",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.357 26.392a.6.6 0 0 1 .286 0l2.125.5a.625.625 0 1 1-.286 1.216l-1.982-.466-1.982.466a.625.625 0 1 1-.286-1.216z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }